import script from "./CompletedCards.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedCards.vue?vue&type=script&setup=true&lang=js"

import "./CompletedCards.vue?vue&type=style&index=0&id=2f290c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f290c22"]])

export default __exports__